import { Col, Row } from "react-bootstrap";
import ModalContainer, {
  ModelContainerProps,
} from "../../ui-elements/modal-container/modal-container";

const EstimationInterruptionModal = (props: ModelContainerProps) => {
  const { show, onCancel, onClose, onConfirm } = props;

  return (
    <ModalContainer
      title={"Estimation Interruption"}
      show={show}
      onCancel={onCancel}
      onClose={onClose}
      onConfirm={onConfirm}
      confirmButtonText="Leave"
      confirmButtonVariant="red"
    >
      <>
        <Row>
          <Col className="font-weight-500 font-size-14 text-color-2">
            Leaving now may cause you to lose progress. Do you still want to
            exit?
          </Col>
        </Row>
        <Row className="mt-2">
          <Col className="font-weight-400 font-size-14  text-color-2">
            Your estimation data will be permanently deleted if you leave the
            page without saving the estimation. Please save your estimation
            before leaving.
          </Col>
        </Row>
      </>
    </ModalContainer>
  );
};

export default EstimationInterruptionModal;
